/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingInvoiceSummary } from './BookingInvoiceSummary';
import type { BookingTherapist } from './BookingTherapist';
import type { MinimalClient } from './MinimalClient';
import type { MinimalDocumentationEntry } from './MinimalDocumentationEntry';
import type { MinimalEventWithCategory } from './MinimalEventWithCategory';
import type { OnlineMeeting } from './OnlineMeeting';
import type { Payment } from './Payment';
export type Booking = {
    createdAt: string;
    moveRequestedStart: string | null;
    moveRequestedEnd: string | null;
    id: number;
    locationSelection: Booking.locationSelection;
    isConfirmed: boolean;
    isOutage: boolean;
    outageFeeApplies: Booking.outageFeeApplies | null;
    price: string;
    outageFeePrice: string | null;
    taxRate: string;
    event: MinimalEventWithCategory;
    client: MinimalClient;
    onlineMeeting: OnlineMeeting | null;
    payment: Payment | null;
    documentationEntries: Array<MinimalDocumentationEntry>;
    moveRequestedLocation: Booking.moveRequestedLocation | null;
    moveRequestedMessage: string | null;
    therapistId?: number;
    therapist?: BookingTherapist;
    invoiceSummary?: BookingInvoiceSummary | null;
    isPaymentArchived?: boolean;
};
export namespace Booking {
    export enum locationSelection {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
    export enum outageFeeApplies {
        YES = 'yes',
        NO = 'no',
        NOT_SELECTED = 'not-selected',
    }
    export enum moveRequestedLocation {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
}

